'use client'
import { useEffect } from 'react'
import { motion, useAnimationControls } from 'framer-motion'

export const TextGenerateHeading = ({
  text,
  className
}: {
  text: string
  className?: string
}) => {
  const controls = useAnimationControls()

  useEffect(() => {
    controls.start({
      opacity: 1,
      transition: { duration: 1 }
    })
  }, [controls])

  return (
    <motion.h1
      initial={{ opacity: 0 }}
      animate={controls}
      className={className}
    >
      {text}
    </motion.h1>
  )
}
